<template>
    <div>
        <check-list :listArray="listArray"></check-list>
    </div>
</template>
<script>
    import CheckList from './check/checkList.vue';

    export default {
        data () {
            return {
                listArray: [
                    {
                        icon:'far fa-check-circle',
                        title:'מערכת סליקה בטוחה ויעילה',
                        text:'קנייה מוצפנת, מאובטחת, נוחה וגמישה הכוללת עבודה מול PayPal ומול כלל חברות האשראי המוכרות.'
                    },
                    {
                        icon:'far fa-check-circle',
                        title:'פאנל ניהול לשליטה מירבית',
                        text:'השרביט בידיים שלכם. שליטה מלאה בכל נושא בחנות: ניהול מוצרים, מלאי, מבצעים, תמונות ועוד אינספור אפשרויות בלחיצת כפתור.'
                    },
                    {
                        icon:'far fa-check-circle',
                        title:'חיפוש עוצמתי שמבין את המשתמש',
                        text:'מערכת החיפוש המהירה, המדויקת והמתקדמת בשוק תאפשר ללקוחות שלכם למצוא כל מוצר בשניות בודדות.'
                    },
                    {
                        icon:'far fa-check-circle',
                        title:'ממשק משתמש אינטואיטיבי ופשוט',
                        text:'יאפשר ללקוחות שלכם להרגיש בבית וישרה בחנות אווירת קנייה שתמכור לכם יותר.'
                    },
                    {
                        icon:'far fa-check-circle',
                        title:'עיצוב מותאם אישית ללא פשרות',
                        text:'חשוב לנו להביא לידי ביטוי את אופי החברה שלכם ולגרום לחנות לשדר בדיוק את מה שאתם מעוניינים לשדר.'
                    },
                    {
                        icon:'far fa-check-circle',
                        title:'SEO',
                        text:'קידום אורגני בגוגל, אתר מהיר ומסודר שמנועי חיפוש ורשתות חברתיות יאהבו לקרוא ולקדם.'
                    },
                    {
                        icon:'far fa-check-circle',
                        title:'Mobile First',
                        text:'זה הרבה יותר מרק רספונסיבי. כל מערכת שלנו מתוכננת בקפידה כדי לעבוד ולהיראות מדהים במכשירים הניידים.'
                    },
                    {
                        icon:'far fa-check-circle',
                        title:'SSL',
                        text:'מערכות שלנו תמיד מגיעות מותאמות לפרוטוקול ההגנה המתקדם בשוק. גם לקוחותכם בטוחים וגם העסק שלכם מצטייר כרציני ומקצועי.'
                    },
                    {
                        icon:'far fa-check-circle',
                        title:'קשר עם הלקוח',
                        text:'קשר נוח ובריא עם הלקוחות ימכור לכם יותר. כל מערכת שלנו מצויידת בטופס יצירת קשר מתקדם ובקישורים בולטים לעמודים שלכם ברשתות החברתיות.'
                    },
                    {
                        icon:'far fa-check-circle',
                        title:'אפליקציית SPA מהירה',
                        text:'כל מערכת שלנו היא בעצם אפליקציית Web חיה, דינמית ומהירה ששווה חוויית משתמש ברמה אחרת.'
                    },
                ],
            }
        },
        components: {
            'check-list': CheckList,
        }
    }
</script>
